(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["j22-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('j22-comparison')) {
  customElements.define('j22-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-j22-open]');
      this.opener.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.locked = true;
      });
      this.querySelector('[data-j22-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => { this.unlock(); this.opener.focus({ preventScroll: true }); });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.querySelectorAll('[data-model]').forEach(button => button.addEventListener('click', () => {
        this.dialog.dataset.selected = button.dataset.model;
        this.querySelectorAll('[data-model]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('.j22-modal-scroll').scrollTop = 0;
      }));
    }
    unlock() { if (this.locked) { document.body.style.overflow = this.previousOverflow; this.locked = false; } }
    disconnectedCallback() { if (this.dialog && this.dialog.open) this.dialog.close(); this.unlock(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
